import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { AddCustomerDetails, UpdateCustomerDetails } from '../../../services/configurationServices'
import { SuccessToast } from '../../../CustomHooks/SuccessToast'
import { ErrorToast } from '../../../CustomHooks/ErrorToast'
import { useCountry } from '../../../CustomHooks/useCountry'
import { useStateMaster } from '../../../CustomHooks/useStateMaster'
import { useCity } from '../../../CustomHooks/useCity'
import { SelectPicker } from 'rsuite';
import { Box, Typography } from '@mui/material'
import { uploadCustomerLogo } from '../../../services/alertAuthService'


const CustomerAdditionForm = ({ setShowAddCustomer, showAddCustomer, selectedRow, fetchFilters }) => {

    const [customerName, setCustomerName] = useState("")
    const [customerNameError, setCustomerNameError] = useState("")
    const [isCustomerFormEdit, setIsCustomerFormEdit] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [selectedCountryId, setSelectedCountryId] = useState("0")
    const [selectedCountryError, setSelecetdCountryError] = useState("")
    const [selectedStateId, setSelecetdStateId] = useState("0")
    const [selectedStateError, setSelectedStateError] = useState("")
    const [address, setAddress] = useState("")
    const [addressError, setAddressError] = useState("")
    const [selectedCityId, setSelectedCityId] = useState("0")
    const [selectedCityError, setSelectedCityError] = useState("")
    const [selectedCustomerLogo, setSelectedCustomerLogo] = useState(null);
    const [preview, setPreview] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [logoFileName, setLogoFileName] = useState("");
    const [logoBase64, setLogoBase64] = useState("");
    const [isSaving, setIsSaving] = useState(false);


    const { country } = useCountry();
    const { state, getState } = useStateMaster()
    const { city, getCity } = useCity();
    console.log("city", city)
    useEffect(() => {
        console.log("SelectedRow", selectedRow)
        if (selectedRow) {
            console.log("SelectedRow", selectedRow)
            setCustomerName(selectedRow?.ClientName)
            setSelectedCountryId(selectedRow?.countrymasterid)
            getState(selectedRow?.countrymasterid)
            setSelecetdStateId(selectedRow?.statemasterid)
            getCity(selectedRow?.statemasterid)
            setSelectedCityId(selectedRow?.City)
            setAddress(selectedRow?.Address)
            setSelectedCustomerLogo(selectedRow?.URL)
            setSelectedCustomer(selectedRow)
            console.log("SelectedRow", selectedRow)
        }
    }, [selectedRow])

    console.log("selectedCustomer", selectedRow)

    useEffect(() => {
        if (state.length > 0 && selectedRow) {
            let tempCountryStateDetails = state?.filter(item => {
                return item.statemasterid == selectedRow.statemasterid
            })
            console.log("selectedCustomer69", tempCountryStateDetails)
            if (tempCountryStateDetails?.length > 0) {
                setSelecetdStateId(tempCountryStateDetails[0].statemasterid)
            }
            else {
                setSelecetdStateId(selectedRow.statemasterid)
            }
        }
    }, [state])

    useEffect(() => {
        if (city.length > 0 && selectedRow) {
            console.log('selectedRow91', selectedRow)
            console.log('selectedRow91', city)
            if (selectedRow.statemasterid == "") {
                setSelectedCityId('0')
            } else {
                console.log("selectedRow91", selectedRow)
                setSelectedCityId(selectedRow?.City)
            }
        }
        //  setSelectedCityId(selectedRow?.City)
    }, [city])

    console.log('selectedRow91', selectedCityId)

    const handleCountryChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedCountryValue = selectedOption.value;
        const selectedCountryValueId = selectedOption.getAttribute('id');
        setSelectedCountryId(selectedCountryValueId)
        getState(selectedCountryValueId)
    }

    const handleStateChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const selectedStateValueId = selectedOption.getAttribute('id');
        setSelecetdStateId(selectedStateValueId)
        getCity(selectedStateValueId)
    }

    //   const handleCityChange = (e) => {
    //     const selectedOption = e.target.options[e.target.selectedIndex];
    //     const selectedCityValueId = selectedOption.getAttribute('id');
    //     getCity(selectedCityValueId)
    //   }

    const onSaveCustomer = async () => {
        let isValidate = false

        if (customerName == "") {
            setCustomerNameError("Please enter a customer name!")
            isValidate = true;
        }
        if (selectedCountryId == "" || selectedCountryId == null || selectedCountryId == 0) {
            setSelecetdCountryError("Plese select a country name!")
            isValidate = true;

        }
        if (selectedStateId == "" || selectedStateId == null || selectedStateId == 0) {
            setSelectedStateError("Please select a state name!")
            isValidate = true;
        }
        if (address == "" || address == null || address == 0 || address == undefined) {
            setAddressError("Plese enter a address!")
            isValidate = true;
        }
        if (selectedCityId == "" || selectedCityId == null || selectedCityId == 0) {
            setSelectedCityError("Please select a city name!")
            isValidate = true;
        }

        if (isValidate) {
            return;
        }
        
        setIsSaving(true); // Disable the save button
        let user = JSON.parse(localStorage.getItem("user"));
        if (selectedCustomer == null) {
            let addCustomerObj = {
                Userid: user?.Id,
                OrganizationMasterID: user?.OrganizationMasterID.toString(),
                ClientName: customerName.toString().trim(),
                Countryid: selectedCountryId.toString(),
                Stateid: selectedStateId.toString(),
                Address: address.toString().trim(),
                City: selectedCityId.toString(),
                Base64String: logoBase64,

            }
            AddCustomerDetails(addCustomerObj).then((resp) => {
                if (resp.Status == "success") {
                    const ClientId = resp?.Data?.ClientId;
                    
                    // Only upload logo if logo file exists
                if (logoBase64) {
                    // Get file extension from the uploaded file
                    const fileExtension = logoFileName.split('.').pop().toLowerCase();
                    
                    const logoUploadObj = {
                        ClientId: ClientId,
                        Base64String: logoBase64,
                        ClientName: customerName?.toString().trim(),
                        Userid: user?.Id,
                        DocType: fileExtension, // Dynamic document type
                        AttachedDocTitle: `${customerName?.toString().trim()}_logo.${fileExtension}` // ClientName_logo.extension
                    }
                    uploadCustomerLogo(logoUploadObj).then((logoResp) => {
                        if (logoResp.Status == "success") {
                            SuccessToast(resp.Message)
                            setSelectedCustomer(null)
                            clearCustomerForm()
                            fetchFilters()
                        } else {
                            ErrorToast(logoResp.Message)
                        }
                        setIsSaving(false); // Re-enable the save button
                    }).catch(() => {
                        setIsSaving(false); // Re-enable on error
                    });
            } else {
                        // No logo uploaded, just show success message
                        SuccessToast(resp.Message)
                        setSelectedCustomer(null)
                        clearCustomerForm()
                        fetchFilters()
                        setIsSaving(false); // Re-enable the save button
                    }
                }
                else {
                    ErrorToast(resp.Message);
                    setIsSaving(false); // Re-enable the save button on error
                }
            }).catch(() => {
                setIsSaving(false); // Re-enable on API error
            });

        }
        else {
            let updateCustomerObj = {
                ClientId: selectedCustomer?.ClientId,
                OrganizationMasterID: user?.OrganizationMasterID.toString(),
                ClientName: customerName.toString().trim(),
                Countryid: selectedCountryId.toString(),
                Stateid: selectedStateId.toString(),
                Address: address.toString().trim(),
                City: selectedCityId.toString(),
                AddressId: selectedCustomer?.AddressId
            }
            UpdateCustomerDetails(updateCustomerObj).then((resp) => {
                if (resp.Status == "success") {
                    // Only upload logo if logo file exists
                    if (logoBase64) {
                        // Get file extension from the uploaded file
                        const fileExtension = logoFileName.split('.').pop().toLowerCase();
                        
                        const logoUploadObj = {
                            ClientId: selectedCustomer?.ClientId,
                            Base64String: logoBase64,
                            ClientName: customerName?.toString().trim(),
                            Userid: user?.Id,
                            DocType: fileExtension, // Dynamic document type
                            AttachedDocTitle: `${customerName?.toString().trim()}_logo.${fileExtension}` // ClientName_logo.extension
                        }
                        uploadCustomerLogo(logoUploadObj).then((logoResp) => {
                            if (logoResp.Status == "success") {
                                setIsCustomerFormEdit(false)
                                SuccessToast(resp.Message);
                                fetchFilters()
                            } else {
                                ErrorToast(logoResp.Message)
                            }
                            setIsSaving(false); // Re-enable the save button
                        }).catch(() => {
                            setIsSaving(false); // Re-enable on error
                        });
                    } else {
                        // No logo uploaded, just show success message
                        setIsCustomerFormEdit(false)
                        SuccessToast(resp.Message);
                        fetchFilters()
                        setIsSaving(false); // Re-enable the save button
                    }
                } else {
                    ErrorToast(resp.Message)
                    setIsSaving(false); // Re-enable the save button on error
                }
            }).catch(() => {
                setIsSaving(false); // Re-enable on API error
            })
        }
    }

    const clearCustomerForm = () => {
        setCustomerName("")
        setCustomerNameError("")
        setIsCustomerFormEdit(false)
        setSelecetdCountryError("")
        setSelectedCountryId("0")
        setSelecetdStateId("0")
        setSelectedStateError("")
        setSelectedCityError("")
        setSelectedCityId("0")
        setAddress("")
        setAddressError("")
        setPreview(null)
        setLogoFile(null)
        setLogoFileName("")
        setLogoBase64("")
        setIsSaving(false)
    }

    const statePickerData = state.map(val => ({
        label: val.statename,
        value: val.statemasterid
    }));

    const countryPickerData = country.map(val => ({
        label: val.countryname,
        value: val.countrymasterid
    }));

    const cityPickerData = city.map(val => ({
        label: val.CityName,
        value: val.CityID
    }));

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file.type.split('/')[0];
            if (fileType === 'image') {
                if (file.size <= 5242880) { // 5MB limit
                    const imageUrl = URL.createObjectURL(file);
                    setPreview(imageUrl);
                    setLogoFileName(file.name); 
                    handleLogoChange(file); 
                    
                    // Convert to Base64
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = (e) => {
                        setLogoBase64(e.target.result);
                    };
                } else {
                    console.log('File size should be less than 5MB.');
                }
            } else {
                console.log('Please select an image file for logo.');
            }
        }
    };

   const handleLogoChange = (file) => {
    setLogoFile(file); 
  };
    return (
        <div className="SiteMainContainer SiteTableMainDiv p-2">
            <h5>{selectedRow == null ? 'Add customer' : 'Edit customer'}</h5>
            {/* Add your form components here */}
            <div className='SiteFormAdditionForm'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Customer Name*</label>
                                <input
                                    className="inputType"
                                    placeholder="Customer Name*"
                                    value={customerName}
                                    disabled={!isCustomerFormEdit && selectedRow != null}
                                    onChange={(e) => {
                                        setCustomerName(e.target.value)
                                        setCustomerNameError("")
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{customerNameError}</span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select Country*</label>
                                <select className="inputType ArrowSelectClass"
                                    value={selectedCountryId}
                                    // disabled={isCustomerFormEdit}
                                    onChange={(e) => {
                                        handleCountryChange(e)
                                        setSelecetdCountryError('')
                                    }}
                                >
                                    <option key="0" disabled={false} value="0" id="0">Select Country*</option>
                                    {country &&
                                        country.map((val) => (
                                            <option value={val.countrymasterid} key={val.countrymasterid} id={val.countrymasterid}>
                                                {val.countryname}
                                            </option>
                                        ))}
                                </select>
                                {/* <SelectPicker
                                className='inputTypeSelectPicker'
                                menuClassName="RS_SelectDropdown"
                                data={countryPickerData}
                                style={{ width: "100%" }}
                                value={selectedCountryId}
                                onChange={value => {
                                    setSelectedCountryId(value);
                                    getState(value);
                                    setSelecetdCountryError('');
                                }}
                                placeholder="Select Country*"
                                /> */}
                                <p className="Error_P" style={{ float: "left" }}><span> {selectedCountryError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select State*</label>
                                <select className="inputType ArrowSelectClass"
                                    value={selectedStateId}
                                    //disabled={isCustomerFormEdit}
                                    onChange={(event) => {
                                        handleStateChange(event)
                                        setSelectedStateError('')
                                    }}>
                                    <option key="0" disabled={false} value="0">Select State*</option>
                                    {state && state.map((val) => (
                                        <option value={val.statemasterid} key={val.statemasterid} id={val.statemasterid}>
                                            {val.statename}
                                        </option>
                                    ))}
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> {selectedStateError} </span></p>

                                {/* <SelectPicker
                                className='inputTypeSelectPicker'
                                menuClassName="RS_SelectDropdown"
                                data={statePickerData}
                                style={{ width: "100%" }}
                                value={selectedStateId}
                                onChange={value => {
                                    setSelecetdStateId(value);
                                    getCity(value);
                                    setSelectedStateError('');
                                }}
                                placeholder="Select State*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {selectedStateError} </span></p> */}
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Select City*</label>
                                <select className="inputType ArrowSelectClass"
                                    //disabled={isCustomerFormEdit}
                                    value={selectedCityId}
                                    onChange={(e) => {
                                        setSelectedCityError('')
                                        setSelectedCityId(e.target.value)
                                    }}
                                >
                                    <option key="0" disabled={false} value="0">Select City*</option>
                                    {city &&
                                        city.map((val) => (
                                            <option value={val.CityName} key={val.CityID}>
                                                {val.CityName}
                                            </option>
                                        ))}
                                </select>
                                {/* <SelectPicker
                                className='inputTypeSelectPicker'
                                menuClassName="RS_SelectDropdown"
                                data={cityPickerData}
                                style={{ width: "100%" }}
                                value={selectedCityId}
                                onChange={value => {
                                    setSelectedCityId(value);
                                    setSelectedCityError('');
                                }}
                                placeholder="Select City*"
                                /> */}
                                <p className="Error_P" style={{ float: "left" }}><span> {selectedCityError} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Address*</label>
                                <input
                                    className="inputType"
                                    placeholder="Address*"
                                    value={address}
                                    disabled={isCustomerFormEdit}
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        setAddressError("")
                                    }}
                                />
                                <p className="Error_P" style={{ float: "left" }}><span>{addressError}</span></p>
                            </div>
                        </div>
                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Region</label>
                                <input
                                    className="inputType"
                                    placeholder="Region*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                            </div>
                        </div> */}

                        <div className="inputMainContainer w40dot75rem mt35">
                            <Box
                                sx={{
                                    border: '2px dashed #1976d2',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    position: 'relative',
                                }}
                                onClick={() => document.getElementById('logo-upload').click()}
                                >
                                {preview || selectedCustomerLogo ? (
                                    <>
                                    <img
                                        src={preview || selectedCustomerLogo}
                                        alt="Logo Preview"
                                        style={{ maxHeight: '150px', maxWidth: '100%', objectFit: 'contain' }}
                                    />
                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                        {logoFileName || (selectedCustomerLogo ? "Current Logo" : "")}
                                    </Typography>
                                    </>
                                ) : (
                                    <>
                                    <Typography variant="body1" color="textSecondary">
                                        Click to upload customer logo
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
                                        Max 5MB • PNG/JPEG only
                                    </Typography>
                                    </>
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    id="logo-upload"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                                </Box>
                        </div>

                    </div>
                </form>
            </div>
            <div style={{ textAlign: "center" }}>
                <button 
                    className="DataAccessEdit" 
                    style={{ 
                        width: "100px", 
                        opacity: isSaving ? 0.6 : 1,
                        cursor: isSaving ? 'not-allowed' : 'pointer'
                    }} 
                    onClick={onSaveCustomer}
                    disabled={isSaving}
                >
                    {/* <span className="ViewUpdate">{selectedRow == null ? 'Save' : 'Update'}</span> */}
                    <span className="ViewUpdate">{isSaving ? 'Saving...' : 'Save'}</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setShowAddCustomer(false)}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </div>
    )
}

export default CustomerAdditionForm